var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "auto-save-container" }, [_vm.saving ? _c('el-button', { attrs: { "type": "text", "loading": _vm.saving } }, [_vm._v("\n    " + _vm._s(_vm.$t('playTurbo.common.save.text')) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm.savedSuccessfully && !_vm.isOvertime ? _c('span', { ref: "saved-text" }, [_vm._v("\n    " + _vm._s(_vm.$t('playTurbo.common.save.saved')) + "\n  ")]) : _vm._e()], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };